import { render, staticRenderFns } from "./GoogleTranslate.vue?vue&type=template&id=73cb4757"
import script from "./GoogleTranslate.vue?vue&type=script&lang=js"
export * from "./GoogleTranslate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports